import AbstractView from '@/core/view/abstractView';
import template from './regionalComparisonView.tpl';
import styles from './style.module.scss';
import LogUtil from '@/core/utils/logUtil';
import RegionalComparisonModel from './model/regionalComparisonModel';
import AppStateModel from '../../model/appStateModel';
import StepController from './steps/stepController';
import JSONLoader from '@/core/loader/jsonLoader';
import Index from './steps/index/index';
import EastWest from './steps/eastwest/eastwest';
import Regional from './steps/regional/regional';

let nextButtonHandler:(event:Event) => void

export default class RegionalComparisonView extends AbstractView {

    private steps:any;
    private stepContainer:HTMLElement|null = null;
    private next_step_buttons:NodeListOf<HTMLElement>|HTMLElement[] = [];
    private active_button:HTMLElement|null = null;

    constructor(id: string, data:any, params:any) {
        super(id, data, params);

        this._template = template({data: this._data, styles: styles});

        nextButtonHandler = (event) => {
            this.nextStep(event)
        };
    }

    preload(completeCallback) {
        let dataFiles = [this._data.model['averages']];

        function loadDataSuccessHandler(result) {
            RegionalComparisonModel.averagesMap = result[0];
            completeCallback();
        }

        function loadDataErrorHandler(error) {
            LogUtil.error('Loading JSON Error. Couldn´t load data.', error);
        }

        JSONLoader.loadAll(dataFiles).then(loadDataSuccessHandler.bind(this), loadDataErrorHandler.bind(this));
    }

    init() {

        this.steps = {
            // keys need to match with "a" buttons data-target.
            index: new Index(this._data, this),
            eastwest: new EastWest(this._data),  // only this step is in use / updated 2025
            regional: new Regional(this._data)
        };

        StepController.setTimeline();
        StepController.setSteps(this.steps);
        StepController.setTarget(this.stepContainer);

        if (AppStateModel.canJumpToStepOnce()) {
            StepController.nextStep('eastwest'); // --------------- TODO edit here to start at a different step by default.
            // StepController.nextStep(RegionalComparisonModel.stepContext);
        } else {
            StepController.nextStep('eastwest'); // --------------- TODO edit here to start at a different step by default.
        }

        for (let button of this.next_step_buttons) {
            button.addEventListener('click', nextButtonHandler);
        }
    }

    render() {
        super.render();

        if (this._element) {
            this.stepContainer = this._element?.querySelectorAll('.step')[0] as HTMLElement ?? null;
            this.next_step_buttons = this._element.querySelectorAll('.next_step_button');
        }


    }

    nextStepByProxy(event) {

        let target = event.target.tagName === 'A' ? event.target : event.target.parentElement;

        for (let btn of this.next_step_buttons) {
            if (btn?.getAttributeNode('data-target')?.value === target.getAttributeNode('data-target').value) {
                this.nextStep({target: btn});
                return; // stop after first match
            }
        }
    }

    nextStep(event) {

        let target = event.target.tagName === 'A' ? event.target : event.target.parentElement;

        if (this.active_button) this.active_button.classList.remove('active');

        this.active_button = target;
        if (this.active_button) this.active_button.classList.add('active');

        StepController.nextStep(target.getAttributeNode('data-target').value);
    }

    destroy() {

        StepController.reset();

        for (let button of this.next_step_buttons) {
            button.removeEventListener('click', nextButtonHandler);
        }
    }
}

